<template>
  <section v-if="data">
    <NuxtPage :page-key="route => route.fullPath" />
    <PagesEventsComponent :data="data" />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
useHead({
  htmlAttrs: { 'data-page-type': 'events' }
})

// 2
const i18nActiveIso = baseI18nGetActiveIso()

const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryEventsPage(i18nActiveIso) )
)

basePageSetHead(data)
</script>
